import React, { Component } from 'react'
import { Nav } from '../../../components'
import {Link, NavLink} from 'react-router-dom'
import Router from './../../../services/Router'
import {Facebook, Twitter, Instagram, Weibo, SimpleFilter} from './../../../components'
import { SocialStyle, ButtonLoadMoreStyle, SimpleFilterStyle } from '../../../styles'
import { withLoader } from '../../../hoc/withLoader'

class Social extends Component {
  state = {
    nav: [
      {
        value: 'Publications',
        url: Router.publications.path
      },
      {
        value: 'Social Wall',
        url: `${Router.social.exactPath}/instagram`
      },
    ],
    filters: [
      {
        label: 'instagram',
        slug: 'instagram',
        icon: <Instagram width={24} height={24} />,
      },
      {
        label: 'twitter',
        slug: 'twitter',
        icon: <Twitter width={24} height={24} />,
      },
      {
        label: 'facebook',
        slug: 'facebook',
        icon: <Facebook width={24} height={24} />,
      },
      {
        label: 'weibo',
        slug: 'weibo',
        icon: <Weibo width={24} height={24} />,
      },
    ],
    count: 6,
  }

  componentWillReceiveProps({data, match}) {
    if (data !== this.props.data || match.params.filter !== this.props.match.params.filter) {
      const nextFilter = match.params.filter
      let filteredData = nextFilter ? data.filter(social => social.type === match.params.filter) : data

      let i = 0
      let increase = 0
      const nData = [
        [],
        [],
        [],
      ]

      filteredData.map((social) => {
        nData[i].push(social)
        i = i < 2 ? i + 1 : 0
        increase = increase + 1
        if (increase === filteredData.length -1 ) {
          this.setState({ socials: nData })
        }
        return social
      })
      return nData
    }
  }

  getMore = () => {
    this.setState({ count: this.state.count + 6 })
  }

  getPictureID(link, type) {
    const linkSplit = link.split('/')
    const subNum = type === 'facebook' ? 3 : 2
    return linkSplit[linkSplit.length - subNum]
  }

  render () {
    const { nav, filters, count, socials } = this.state
    const { match, isReady } = this.props

    return (
      <div className={` social ${SocialStyle} ${ButtonLoadMoreStyle}`}>
        <div className="page-inner">
          <div className="social-nav">
            <Nav nav={nav} />
          </div>
          <div className="social-filter">
            <ul className={`simple-filter ${SimpleFilterStyle} reset flex`}>
              {
                filters && filters.map((filter, index) => (
                  <li key={index} className='simple-filter-item'>
                    <NavLink to={ `${Router.social.exactPath}/${filter.label}`} exact >
                      {
                        filter.icon && filter.icon
                      }
                      <span>  {filter.label} </span>
                    </NavLink>
                  </li>
                ))
              }
            </ul>
          </div>
          <div className={` social-container flex transition ${isReady ? 'transition--ready' : '' }`}>

            {
              socials &&
              socials.map((row, index) => (
                <div className="social-col" key={index}>
                  {
                    row
                      .slice(0, count)
                      .map((social, index) => (
                        <div className="social-box" key={index}>
                          <a href={social.link} target='_blank'>
                            <div className="flex">
                              <div className="social-type">
                                { social.type === 'facebook' && (<Facebook width={24} height={24} />) }
                                { social.type === 'twitter' && <Twitter width={24} height={24} /> }
                                { social.type === 'instagram' && <Instagram width={24} height={24} /> }
                                { social.type === 'weibo' && <Weibo width={24} height={24} /> }
                              </div>
                              <div className="social-head">
                                <h3 className="social-title">{ social.account_name }</h3>
                                <span className="social-date">{ social.date }</span>
                              </div>
                            </div>
                            <div className="social-desc" dangerouslySetInnerHTML={{ __html: social.title }} />
                            {
                              social.image && (
                                <div className="social-img">
                                  <img src={social.image} alt="" referrerPolicy="no-referrer"/>
                                </div>
                              )
                            }
                          </a>
                        </div>
                      ))
                  }
                </div>
              ))
            }
          </div>
          {
            socials && count < (socials[0].length + socials[1].length + socials[2].length) / 3  && (
              <button type="button" className="btn btn-load-more" onClick={ this.getMore }>
                Load more
              </button>
            )
          }
        </div>
      </div>
    )
  }
}

export default withLoader(Social, '/social-media')



// WEBPACK FOOTER //
// ./src/scenes/Pages/container/SocialMedia.js